export default "__VITE_ASSET__BJDrHY0l__"